import Analytics from "analytics";
import mixpanelPlugin from "@analytics/mixpanel";
import { analyticsPlugin as peekAnalyticsPlugin, analyticsStorage, googleAnalyticsPlugin, } from "@piiqtechnologies/ui-lib";
import * as Sentry from "@sentry/react";
const analyticsTools = process.env.PEEK_APP_ANALYTICS_TOOLS || "";
const googleAnalytics = googleAnalyticsPlugin({
    measurementIds: [process.env.PEEK_APP_GA_MEASUREMENT_ID],
    gtagConfig: {
        cookie_flags: "SameSite=None;Secure",
    },
    enabled: analyticsTools.includes("GA"),
});
export const analytics = Analytics({
    app: "ai-discoverability",
    debug: true,
    // @ts-ignore
    storage: analyticsStorage,
    plugins: [
        googleAnalytics,
        mixpanelPlugin({
            token: process.env.PEEK_APP_MIXPANEL_TOKEN,
            enabled: analyticsTools.includes("MIXPANEL"),
        }),
        peekAnalyticsPlugin({
            appId: process.env.PEEK_APP_ANALYTICS_APP_ID,
            app: "ai-discoverability",
            enabled: analyticsTools.includes("PEEK"),
        }),
    ],
});
analytics.ready(() => {
    const sessionId = analytics.getState("context.sessionId");
    if (sessionId) {
        Sentry.setTag("session_id", sessionId);
    }
});
export default analytics;
